import { useMemo } from 'react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import HamburgerSvg from '../common/components/svg/HamburgerSvg'
import WootFbaOrdersImport from './components/fba/WootFbaOrdersImport'
import CustomError from '../common/components/CustomError'
import './styles/woot.fba.css'
import WootFbaJourneyComplete from './components/fba/WootFbaJourneyComplete'

/**
 * This component allows users to upload documents emailed to us. 
 * The goal of this component is to automate the following:
 *  - Original PO MC IAG Create (FBA US to FBA WOOT transition)
 *  - Return PO MC Order Create
 *  - Return PO MC IAG Create (Left over from ordered FBA WOOT to FBA US)
 */
export default function WootOrdersImport() {

  const view = useMemo(() => {
    return <div>
      <div id='top'></div>
      <div className='beacon-card'>
        <table className='beacon-table'>
          <tbody>
            <tr>
              <td><span className='beacon-header'>WOOT! Orders</span></td>
            </tr>
            <tr>
              <td><span className='beacon-label'>Create and manage Woot! FBA and Dropship orders import processes.</span></td>
            </tr>
          </tbody>
        </table>
      </div>
      <Tabs>
        <TabList>
          <Tab key='fbaTab'>
            <span className='beacon-header'><HamburgerSvg height={25}/> WOOT! FBA NEW/IN PROGRESS</span>
          </Tab>
          <Tab key='fbaCompleteTab'>
            <span className='beacon-header'><HamburgerSvg height={25}/> WOOT! FBA COMPLETED</span>
          </Tab>
          <Tab key='dropshipTab'>
            <span className='beacon-header'><HamburgerSvg height={25}/> WOOT! DROPSHIP</span>
          </Tab>

        </TabList>
        <TabPanel key='fbaTabPanel'>
          <WootFbaOrdersImport />
          
        </TabPanel>
        <TabPanel key='fbaCompleteTabPanel'>
          <WootFbaJourneyComplete />
        </TabPanel>
        <TabPanel key='dropshipWoot'>
          <CustomError 
            closeError={undefined}
            content={undefined}
            description={'WOOT! Dropship order management has not been implemented yet. We apologize for any inconvenience.'}
            title='WOOT! DROPSHIP ERROR'
            visible={true}
          />
        </TabPanel>
      </Tabs>
    </div>
  }, [])

  return view
}
